<template>
    <div class="row mt-5">
        <div class="offset-md-3 col-md-6">
            <div class="bg-white p-3 shadow-sm rounded-lg">
                <div>
                    <h4 class="font-weight-bold mb-3">Redirecting</h4>
                    <div class="mb-4">
                        <p class="text-muted">Please wait...</p>
                </div>
            </div>
        </div>
        </div>
    </div>
</template>

<script>
export default {
  name: "LoginRedirect",
  data() {
    return {
    };
  },
  mounted() {
    const params = new URLSearchParams(window.location.search);
    const encoded = params.get("auth");

    if (encoded) {
      try {
        const decoded = JSON.parse(atob(encoded));

        localStorage.setItem("token", decoded.token);
        localStorage.setItem("user", JSON.stringify(decoded.user));

        setTimeout(() => (window.location.href = '/requests'), 500)

      } catch (e) {
        console.error("Failed to decode auth data", e);
      }
    }
  },
};

</script>

<style scoped>

</style>